import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileViolationDialog } from './dialogs/candidate/file-violation-dialog/file-violations-dialog'
import { RequirementService } from './service/requirement-service';
import { CandidateService } from './service/candidate-service';
import { FilePreviewDialogComponent } from './dialogs/candidate/file-preview-dialog/file-preview-dialog.component';
import { FileDownloadUtil } from './utils/candidate/file-download-util';
import { CandidateFormsUtil } from './utils/candidate/candidate-form-util';
import { FileUploadUtil } from './utils/candidate/file-upload-util';
import { DatatableFiltersUtil } from './utils/requisition/datatable-filter-util';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { FilePreviewUtil } from './utils/candidate/file-preview-util';
import { MatSliderModule } from '@angular/material/slider';
import { ProfilePicPreviewBottomSheetComponent, ProfilePicPreviewComponent } from './dialogs/candidate/profile-pic-preview/profile-pic-preview.component';
import { QuestionnaireFormUtil } from './utils/candidate/questionnaire-form-util';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SafePipe } from './utils/sanitizer.pipe';
import { JwtInterceptor } from '../auth/jwt.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MDBBootstrapModule, IconsModule } from 'angular-bootstrap-md';
import { NoAccessBottomSheetComponent, NoAccessDialogComponent } from './dialogs/auth/no-access-dialog/no-access-dialog.component';
import { ValidationHighlightsUtil } from './utils/candidate/validation-highlights';
import { DialoCodeFilterPipe } from './utils/dialcode-filter.pipe';
import { CarouselService } from './utils/carousel-service.service';
import { FormSubmissionErrorsDialog } from './dialogs/form-submission-error-dialog/form-submission-error-dialog';
import { OnboardService } from './service/onboard-service';
import { DateFormatPipe } from './filter-pipe.pipe';
import { OnboardCreateComponent } from '../onboard-create/onboard-create.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OnboardFormsUtil } from '../onboard-create/onboard-forms-util';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { JobSourcingDialog } from './dialogs/job-sourcing/job-sourcing.component';
import { GoToOriginalDialog } from './dialogs/goto-original-dialog/goto-original-dialog.component';
import { CustomSnackbarComponent } from './component/custom-snackbar/custom-snackbar.component';


@NgModule({
  declarations: [
    DateFormatPipe,
    FileViolationDialog,
    // FileViolationBottomSheet,
    FilePreviewDialogComponent,
    FormSubmissionErrorsDialog,
    GoToOriginalDialog,
    ProfilePicPreviewComponent,
    ProfilePicPreviewBottomSheetComponent,
    SafePipe,
    NoAccessDialogComponent,
    NoAccessBottomSheetComponent,
    DialoCodeFilterPipe,
    OnboardCreateComponent,
    JobSourcingDialog,
    CustomSnackbarComponent,
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MatMenuModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTableModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatIconModule,
    MatSidenavModule,
    MatCardModule,
    MatSortModule,
    MatDividerModule,
    MatInputModule,
    MatListModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    MatSliderModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatExpansionModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MDBBootstrapModule.forRoot(),
  ],
  exports: [
    MatFormFieldModule,
    MatInputModule,
    DateFormatPipe,
    FilePreviewDialogComponent,
    FormSubmissionErrorsDialog,
    GoToOriginalDialog,
    ProfilePicPreviewComponent,
    SafePipe,
    NoAccessDialogComponent,
    NoAccessBottomSheetComponent,
    DialoCodeFilterPipe,
    OnboardCreateComponent,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatTabsModule,
    MatSelectModule,MatCheckboxModule
  ],
  providers: [
    RequirementService,
    CandidateService,
    OnboardService,
    FileDownloadUtil,
    CandidateFormsUtil,
    OnboardFormsUtil,
    FileUploadUtil,
    DatatableFiltersUtil,
    FilePreviewUtil,
    QuestionnaireFormUtil,
    ValidationHighlightsUtil,
    OnboardCreateComponent,
    CarouselService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  entryComponents:[
    OnboardCreateComponent,
  ]
})
export class SharedModule { }
